import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Table, Text, FormElements, ActionLink, stickyHeader, stickyStyle } from '@custom-components';
import { Formik } from 'formik';
import LocaleLink from '../../../../components/LocaleLink';
import { OverflowContainer, PulseWrapper, ProfileContainer, UserInfo } from '../List.styles';
import { featureFlagShape } from '../helperFunctions';
import { ToastContext } from '../../../../components/ToastWrapper';

class FeatureFlagTable extends PureComponent {
  activateFeatureFlag = async (featureId, active, featureName) => {
    const { mutations } = this.props;
    const { activateFeatureFlag, updateList } = mutations;
    const { createToast } = this.context;
    try {
      await activateFeatureFlag(featureId, active);
      createToast(`${featureName} successfully ${active ? 'activated' : 'deactivated'}`, { variant: 'success' });
      await updateList();
    } catch {
      createToast('Something went wrong, please try again.', { variant: 'error' });
    }
  };

  renderRows = () => {
    const { data } = this.props;
    if (!data) return null;

    return data.map((feature) => {
      const { id, featureName, description, active, organizationMappings, activeOrgsCount } = feature;
      return {
        id,
        name: (
          <ProfileContainer>
            <UserInfo>
              <Text.CopyBody weight="bold" tagName="p" noMargins>
                {featureName}
              </Text.CopyBody>
            </UserInfo>
          </ProfileContainer>
        ),
        description: (
          <div>
            <Text.CopyParagraph tagName="span">{description || ''}</Text.CopyParagraph>
          </div>
        ),
        orgs: (
          <div>
            {activeOrgsCount}/{organizationMappings.length}
          </div>
        ),
        active: (
          <div>
            <Formik
              initialValues={{
                featureId: id,
                active,
                featureName
              }}
              enableReinitialize
            >
              {({ values, setFieldValue }) => (
                <FormElements.Switch
                  name="featureActivated"
                  id="featureActivated"
                  checked={values.active}
                  onChange={(event, checked) => {
                    setFieldValue('active', !!checked);
                    this.activateFeatureFlag(id, checked, featureName);
                  }}
                />
              )}
            </Formik>
          </div>
        ),
        actionLink: (
          <LocaleLink route="FeatureFlagOverview" params={{ id: id.toString() }}>
            <ActionLink>
              <Text.HeadingSixth noMargins>View Details</Text.HeadingSixth>
            </ActionLink>
          </LocaleLink>
        )
      };
    });
  };

  render() {
    return (
      <OverflowContainer>
        <PulseWrapper>
          <Table
            minTableWidth="100%"
            headerCellsConfig={{ roles: { width: '200px' }, actionLink: { style: stickyHeader } }}
            contentCellsConfig={{ actionLink: { style: stickyStyle } }}
            rows={[
              { id: 'featureName', label: 'Feature Flag Name' },
              { id: 'description', label: 'Description' },
              { id: 'activeOrganizations', label: 'Active Organizations' },
              { id: 'active', label: 'Active' },
              { id: 'actionLink' }
            ]}
          >
            {this.renderRows()}
          </Table>
        </PulseWrapper>
      </OverflowContainer>
    );
  }

  // eslint-disable-next-line react/static-property-placement, react/sort-comp
  static contextType = ToastContext;
}

FeatureFlagTable.propTypes = {
  data: PropTypes.arrayOf(featureFlagShape).isRequired,
  messages: PropTypes.shape({}),
  mutations: PropTypes.shape({
    activateFeatureFlag: PropTypes.func,
    updateList: PropTypes.func
  })
};

FeatureFlagTable.defaultProps = {
  messages: {
    nameLabel: 'Name',
    contactInfoLabel: 'Contact Info',
    actionHeaderLabel: ''
  },
  mutations: {}
};

export default FeatureFlagTable;
